import { useState, useRef, useTransition, useCallback, useEffect } from "react";

export const useCopyToClipboard = () => {
  const [copyState, setCopyState] = useState<"idle" | "copied">("idle");
  const [isPending, startTransition] = useTransition();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const copy = useCallback((text: string) => {
    if (!text || text.trim() === "") return;

    startTransition(() => {
      navigator.clipboard.writeText(text)
        .then(() => {
          setCopyState("copied");
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
          timeoutRef.current = setTimeout(() => {
            setCopyState("idle");
            timeoutRef.current = null;
          }, 2000);
        })
        .catch((error) => {
          console.error("Failed to copy to clipboard:", error);
        });
    });
  }, []);

  const reset = useCallback(() => {
    setCopyState("idle");
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return { copyState, copy, reset, isPending };
};